<template>
  <div class="first">
    <app-header></app-header>
    <div class="finishGame">
      <div>
        <span class="text">
        Вы завершили тестирование.
      </span>
      </div>
      <div style="margin-top: 50px;">
        <router-link :to="{name: 'Start', params: {slug: orgSlug}}">
          <span class="btn">
            Вернуться к пользователю
          </span>
        </router-link>
        <span class="btn" @click="logout()">
          Вернуться к выбору пользователя
        </span>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
  export default {
    name: 'FinishGame',
    data () {
      return {
        orgSlug: '',
        clicked: false
      }
    },
    mounted () {
      this.orgSlug = this.$route.params.slug
    },
    methods: {
      logout () {
        this.clicked = false
        this.$store.dispatch('signout')
        this.$router.push({name: 'Start'})
      }
    }
  }
</script>

<style scoped lang="scss">
  .first {
    display: flex;
    flex-direction: column;
  }

  .finishGame {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 790px;
  }

  .text {
    font-size: 22px;
    font-weight: 300;
  }

  .btn {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
    margin: 0 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/game/FinishGame.vue